import Layout from '@/layout';

/**
 * 商户端仓储：寄卖模式下商户是货主，只看自己的货。
 * 平台仓库的作业环节（货架库位/波次/拣货/复核/装箱/盘点）不对商户开放。
 */
var warehouseRouter = {
  path: '/warehouse',
  component: Layout,
  redirect: '/warehouse/stock',
  name: 'MerWarehouse',
  meta: {
    title: '我的仓储',
    icon: 'shopping'
  },
  children: [{
    path: 'stock',
    component: function component() {
      return import('@/views/warehouse/stock');
    },
    name: 'MerWarehouseStock',
    meta: {
      title: '我的库存',
      icon: ''
    }
  }, {
    path: 'batch',
    component: function component() {
      return import('@/views/warehouse/batch');
    },
    name: 'MerWarehouseBatch',
    meta: {
      title: '批次与效期',
      icon: ''
    }
  }, {
    path: 'inbound',
    component: function component() {
      return import('@/views/warehouse/inbound');
    },
    name: 'MerWarehouseInbound',
    meta: {
      title: '入库记录',
      icon: ''
    }
  }, {
    path: 'outbound',
    component: function component() {
      return import('@/views/warehouse/outbound');
    },
    name: 'MerWarehouseOutbound',
    meta: {
      title: '出库记录',
      icon: ''
    }
  }, {
    path: 'return',
    component: function component() {
      return import('@/views/warehouse/returnApply');
    },
    name: 'MerWarehouseReturn',
    meta: {
      title: '退库申请',
      icon: ''
    }
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/warehouse/record');
    },
    name: 'MerWarehouseRecord',
    meta: {
      title: '库存流水',
      icon: ''
    }
  }]
};
export default warehouseRouter;